import type { ExternalInvoiceFromBilly } from '@features/invoices/types/externalInvoiceFromBilly'

import { ImportedInvoicePaymentStatus } from '../types/importedInvoicePaymentStatus'

/**
 * Reads the payment status off the Billy balance. Unpaid while there is a balance left, paid once
 * it is settled by payments. A settled balance with no payments has nothing to register or void.
 */
export const getExternalInvoicePaymentStatus = (
  externalInvoice: ExternalInvoiceFromBilly,
): ImportedInvoicePaymentStatus | undefined => {
  if (externalInvoice.balance > 0) {
    return ImportedInvoicePaymentStatus.Unpaid
  }

  if (externalInvoice.balanceModifiers?.length) {
    return ImportedInvoicePaymentStatus.Paid
  }

  return undefined
}
